import React, {Component} from 'react';
import './App.scss';
import {Outlet} from "react-router-dom";
import {initIconsLibrary} from "./utils/init_icons_library";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {IntercomScript} from "./IntercomScript";
import {ErrorBoundary} from "./components/ErrorBoundary";
import {AgencyStatusRefresher} from "./components/AgencyStatusRefresher";
import {FreeTrialBanner} from "./components/FreeTrialBanner";
import {HelpDrawerProvider} from "./components/help/HelpDrawerContext";
import {HelpDrawer} from "./components/help/HelpDrawer";
// import {MaintenanceBanner} from "./components/MaintenanceBanner";


initIconsLibrary();

class App extends Component {
    render() {
        return (
            <ErrorBoundary showDetails={process.env.NODE_ENV === 'development'}>
                <HelpDrawerProvider>
                    <div>
                        {/* <MaintenanceBanner/> */}
                        <FreeTrialBanner/>
                        <ToastContainer
                            position="top-right"
                            autoClose={5000}
                            hideProgressBar
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                        <IntercomScript/>
                        <AgencyStatusRefresher/>
                        <Outlet/>
                        <HelpDrawer/>
                    </div>
                </HelpDrawerProvider>
            </ErrorBoundary>
        );
    }
}


export default App;
